<template>
    <app-layout>
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                Create Partner
            </h2>
        </template>

        <partner-form :action="route('partners.store')" method="POST" button="CREATE"></partner-form>
    </app-layout>
</template>

<script>
    import AppLayout from '@/Layouts/AppLayout';
    import PartnerForm from './Form';

    export default {
        components: {
            AppLayout,
            PartnerForm,
        },
    }
</script>
